import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {ColorFill} from '@Components/color-fill';
import type {ColorStorage} from '@Components/color-picker-v2';
import {GRADIENT_STOP_SWATCH_SIZE} from './gradient-stop-swatches.types';
import type {GradientStopSwatchesProps} from './gradient-stop-swatches.types';

/** The popup's "Colors" row: one round swatch per gradient stop, selecting which stop the picker below edits. */
export function GradientStopSwatches(props: GradientStopSwatchesProps): ReactElement {
  const getStopSwatch = (colorStorage: ColorStorage): ReactElement => {
    return (
      <ColorFill
        key={colorStorage.id}
        id={colorStorage.id}
        color={colorStorage.color}
        width={GRADIENT_STOP_SWATCH_SIZE}
        height={GRADIENT_STOP_SWATCH_SIZE}
        borderRadius={GRADIENT_STOP_SWATCH_SIZE / 2}
        isSelected={colorStorage.id === props.selectedColorId}
        onClick={(): void => {
          props.onChangeSelectedColor(colorStorage.id);
        }}
      />
    );
  };

  return (
    <div className="flex-v-row gap-2">
      <Text val={window.i18next.t('pmwjs_colors')} size={TextSize.MD} />
      <div className="flex-h-row flex-wrap gap-3">{props.color.map(getStopSwatch)}</div>
    </div>
  );
}
